<div class="overlay" *ngIf="loading">
  <div class="spinner-wrapper">
    <app-spinner>
      <span style="font-size: 3em; color: #27AE61;"><i class="fal fa-atom-alt fa-spin"></i></span>
    </app-spinner>
  </div>
</div>

<form [formGroup]="requisitionEditForm">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          Requisition Edit - {{requisition.Accession}}
          <div class="float-right">
            <a (click)="updateRequisition()" class="iconbutton" title="Save" [ngClass]="(requisitionEditForm.invalid || !requisitionEditForm.dirty) ? 'disabled' : ''">
              <i class="fa fa-save"></i>
            </a>
            <a (click)="cancel()" class="iconbutton" title="Cancel">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
        <div class="card-body">
          <div class="row">

            <div class="col-4">
              <div class="card">
                <div class="card-header">
                  Patient Information
                </div>

                <div class="card-body">
                  <div class="row">
                    <div class="inputlabel col-3"><label>First Name:</label></div>
                    <div class="inputstyle col-9">
                      <div><input formControlName="firstName" id="firstName" type="text" focus="true" class="inputstyle" pInputText [value]="requisition.FirstName" /></div>
                      <div *ngIf="requisitionEditForm.controls['firstName'].errors?.required" class="valdiation-message-small">
                        * Required
                      </div>
                      <div *ngIf="requisitionEditForm.controls['firstName'].errors?.nowhitespace" class="valdiation-message-small">
                        * Spaces are not allowed
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="inputlabel col-3"><label>Last Name:</label></div>
                    <div class="inputstyle col-9">
                      <input formControlName="lastName" id="lastName" type="text" class="inputstyle" pInputText [value]="requisition.LastName" />
                      <div *ngIf="requisitionEditForm.controls['lastName'].errors?.required" class="valdiation-message-small">
                        * Required
                      </div>
                      <div *ngIf="requisitionEditForm.controls['lastName'].errors?.nowhitespace" class="valdiation-message-small">
                        * Spaces are not allowed
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-3"><label>Birth Date:</label></div>
                    <div class="col-9">
                      <kendo-datepicker formControlName="birthDate" [style.width]="'140px'" [min]="minbdate" [max]="maxbdate"
                                        (afterValueChanged)="handleBirthDateChange($event)" [format]="'MM/dd/yyyy'">
                      </kendo-datepicker>
                      <div *ngIf="requisitionEditForm.controls['birthDate'].errors?.required" class="valdiation-message-small">
                        * Required
                      </div>
                      <div *ngIf="requisitionEditForm.controls['birthDate'].errors?.minBirthDate" class="valdiation-message-small">
                        * Birth date must be great than {{formattedminbdate}}
                      </div>
                      <div *ngIf="requisitionEditForm.controls['birthDate'].errors?.maxBirthDate" class="valdiation-message-small">
                        * Birth date must be less than {{formattedmaxbdate}}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="inputlabel col-3"><label>Gender:</label></div>
                    <div class="col-8" style="margin-top:10px">
                      <kendo-dropdownlist formControlName="gender" [valuePrimitive]="true" [value]="requisition.Gender" style="width:100%"
                                          [data]="genderList" [valueField]="'Code'" [textField]="'Description'">
                      </kendo-dropdownlist>
                    </div>
                  </div>
                  <div class="row">
                    <div class="inputlabel col-3"><label>Race:</label></div>
                    <div class="col-8" style="margin-top:10px">
                      <kendo-dropdownlist formControlName="race" [valuePrimitive]="true" [value]="requisition.Race" style="width:100%"
                                          [data]="raceList" [valueField]="'Code'" [textField]="'Description'">
                      </kendo-dropdownlist>
                    </div>
                  </div>

                  <div class="row">
                    <div class="inputlabel col-3"><label>Ethnicity:</label></div>
                    <div class="col-8" style="margin-top:10px; margin-bottom: 10px">
                      <kendo-dropdownlist formControlName="ethnicity" [valuePrimitive]="true" [value]="requisition.Ethnicity" style="width:100%"
                                          [data]="ethnicityList" [valueField]="'Code'" [textField]="'Description'">
                      </kendo-dropdownlist>
                    </div>
                  </div>

                  <div class="row">
                    <div class="inputlabel col-3"><label>Address1</label></div>
                    <div class="inputstyle col-9">
                      <input formControlName="address1" id="address1" type="text" class="inputstyle" pInputText [value]="requisition.Address1" />
                      <div *ngIf="requisitionEditForm.controls['address1'].errors?.required" class="valdiation-message-small">
                        * Required
                      </div>
                      <div *ngIf="requisitionEditForm.controls['address1'].errors?.nowhitespace" class="valdiation-message-small">
                        * Spaces are not allowed
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="inputlabel col-3"><label>Address2</label></div>
                    <div class="inputstyle col-9">
                      <input formControlName="address2" id="address2" type="text" class="inputstyle" pInputText [value]="requisition.Address2" />
                      <div *ngIf="requisitionEditForm.controls['address2'].errors?.nowhitespace" class="valdiation-message-small">
                        * Spaces are not allowed
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="inputlabel col-3"><label>City</label></div>
                    <div class="inputstyle col-9">
                      <input formControlName="city" id="city" type="text" class="inputstyle" pInputText [value]="requisition.City" />
                      <div *ngIf="requisitionEditForm.controls['city'].errors?.required" class="valdiation-message-small">
                        * Required
                      </div>
                      <div *ngIf="requisitionEditForm.controls['city'].errors?.nowhitespace" class="valdiation-message-small">
                        * Spaces are not allowed
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-3"><label>State:</label></div>
                    <div class="col-8" style="margin-bottom: 10px">
                      <kendo-dropdownlist formControlName="state" [valuePrimitive]="true" [value]="requisition.State" style="width:100%"
                                          [data]="states" [valueField]="'value'" [textField]="'label'">
                      </kendo-dropdownlist>
                      <div *ngIf="requisitionEditForm.controls['state'].errors?.required" class="valdiation-message-small">
                        * Required
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="inputlabel col-3"><label>Zip Code:</label></div>
                    <div class="inputstyle col-9">
                      <input formControlName="zip" id="zip" type="text" class="inputstyle" pInputText [value]="requisition.Zip" />
                      <div *ngIf="requisitionEditForm.controls['zip'].errors?.required" class="valdiation-message-small">
                        * Required
                      </div>
                      <div *ngIf="requisitionEditForm.controls['zip'].errors?.pattern" class="valdiation-message-small">
                        * Invalid
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="inputlabel col-3"><label>Email</label></div>
                    <div class="inputstyle col-9">
                      <input formControlName="email" id="email" type="text" class="inputstyle" pInputText [value]="requisition.Email" />
                      <div *ngIf="requisitionEditForm.controls['email'].errors?.required" class="valdiation-message-small">
                        * Required
                      </div>
                      <div *ngIf="requisitionEditForm.controls['email'].errors?.pattern" class="valdiation-message-small">
                        * Invalid
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="inputlabel col-3"><label>Phone</label></div>
                    <div class="inputstyle col-9">
                      <p-inputMask placeholder="999-999-9999" mask="999-999-9999" formControlName="phone" id="phone"
                                   type="text" class="inputstyle"></p-inputMask>
                      <div *ngIf="requisitionEditForm.controls['phone'].errors?.required" class="valdiation-message-small">
                        * Required
                      </div>
                      <div *ngIf="requisitionEditForm.controls['phone'].errors" class="valdiation-message-small">
                        * Invalid
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="card">
                <div class="card-header">
                  Client Information
                </div>

                <div class="card-body">

                  <div class="row">
                    <div class="inputlabel col-3"><label>Facilities:</label></div>
                    <div class="col-9" style="margin-bottom:10px">
                      <kendo-dropdownlist style="width: 100%" formControlName="facility" [filterable]="true"
                                          style="width:100%" [valuePrimitive]="true" [value]="requisition.FacilityCode"
                                          [data]="facilityListFiltered" [valueField]="'FacilityCode'" [textField]="'FacilityName'"
                                          (filterChange)="facilityFilterChange($event)">
                      </kendo-dropdownlist>
                    </div>
                  </div>
                  <div class="row">
                    <div class="inputlabel col-3"><label>Provider:</label></div>
                    <div class="col-9">
                      <input class="input" placeholder="Provider" formControlName="providerName" readonly
                             id="providerName" type="text" focus="true" pInputText style="width:90%" />
                      <a (click)="showProviderSearch = true;" class="iconbutton" title="Search Providers">
                        <i class="fab fa-searchengin"></i>
                      </a>

                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-4">

              <div class="card">
                <div class="card-header">
                  Sample Info
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="inputlabel col-4"><label>Collected By:</label></div>
                    <div class="inputstyle col-8">
                      <input formControlName="collectedby" id="collectedby" type="text" focus="true" pInputText style="width:100%"
                             [value]="requisition.SpecimenCollectedBy" />
                      <div *ngIf="requisitionEditForm.controls['collectedby'].errors?.required" class="valdiation-message-small">
                        * Required
                      </div>
                      <div *ngIf="requisitionEditForm.controls['collectedby'].errors?.nowhitespace" class="valdiation-message-small">
                        * Spaces are not allowed
                      </div>
                    </div>
                  </div>
                  <div class="row collected">
                    <div class="col-4"><label>Collected Date:</label></div>
                    <div class="col-8">
                      <kendo-datepicker formControlName="collectiondate" [min]="minColldate" [max]="packageDelDate"
                                        style="width:100%" [format]="'MM/dd/yyyy hh:mm a'">
                      </kendo-datepicker>
                      <div *ngIf="requisitionEditForm.controls['collectiondate'].errors?.required" class="valdiation-message-small">
                        * Required
                      </div>
                      <div *ngIf="requisitionEditForm.controls['collectiondate'].errors?.minDate" class="valdiation-message-small">
                        * Collection date must be between {{minColldateFormatted}} and {{packageDeliveredDateFormatted}}
                      </div>
                      <div *ngIf="requisitionEditForm.controls['collectiondate'].errors?.maxDate" class="valdiation-message-small">
                        * Collection date must be between {{minColldateFormatted}} and {{packageDeliveredDateFormatted}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<p-dialog [(visible)]="showProviderSearch" [modal]="true">
  <ng-template #header>
    Provider Search
  </ng-template>
  <div>
      <form #providerSearchForm="ngForm">
        <div class="row">
            <label>Enter name or NPI and click Search</label>
        </div>

        <div class="row">
          <div class="inputlabel col-6"><label>Provider Search:</label></div>
        </div>

        <div class="row">
          <div class="col-11">
            <input placeholder="First Name" [(ngModel)]="this.providerSearch.FirstName" [ngModelOptions]="{standalone: true}" style="width:100%; margin:10px"
                   id="searchFirstName" type="text" pInputText />
          </div>
        </div>

        <div class="row">
          <div class="col-11">
            <input placeholder="Last Name" [(ngModel)]="this.providerSearch.LastName"  [ngModelOptions]="{standalone: true}"style="width:100%; margin:10px;"
                   id="searchLastName" type="text" pInputText />
          </div>
        </div>

        <div class="row">
          <div style="margin-left:40px" class="inputlabel col-3"><label>Or</label></div>
        </div>
        <div class="row">
          <div class="col-11">
            <input class="input" placeholder="Provider NPI" [(ngModel)]="this.providerSearch.NPI" [ngModelOptions]="{standalone: true}"
                   style="width:100%;margin:10px;" id="searchNPI" type="text" pInputText />
          </div>
        </div>
        <div class="row">
          <div *ngIf="displayResultsMessage" class="col-10 valdiation-message-small">
            * No results found
          </div>
          <div *ngIf="providerSearchList.length > 0">
            <div class="col-11" style="margin-bottom:10px;margin-left:5px;">
              <label>Select Provider:</label>
              <ul class="scroll" style="width:100%;text-align:left;">
                <li class="list-group-item" *ngFor="let item of providerSearchList">
                  <input class="col-1" type="radio" id="npi_{{item.NPI}}" name="list_name" value="{{item.NPI}}" required [(ngModel)]="newProviderNPI"/>
                  <label class="col-11" for="npi_{{item.NPI}}">
                    <b>{{item.PhysicianFirstName}} {{item.PhysicianLastName}}</b> {{item.PhysicianCredentials}} ({{item.NPI}})
                    <span class="small">
                      <span [hidden]="!item.PhysicianAddress1">{{item.PhysicianAddress1}}</span>
                      <span [hidden]="!item.PhysicianAddress2"> {{item.PhysicianAddress2}}</span>
                      <span> {{item.PhysicianCity}} {{item.PhysicianState}}</span>
                    </span>
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </form>
</div>
  <ng-template #footer>
    <button (click)="searchProvider()" style="margin-right:10px;margin-left:10px">
      <i class="fa fa-search"></i> Search
    </button>
    <button (click)="changeProvider()" style="margin-right:10px;margin-left:10px" [disabled]="newProviderNPI == 0">
      <i class="fa fa-save"></i> Save
    </button>
    <button (click)="closeProviderSearch()" class="float-right" style="margin-right:10px;margin-left:10px">
      <i class="fa fa-times"></i> Close
    </button>
  </ng-template>
</p-dialog>
